import React from 'react';
import { Form, FormGroup, Label, Input, Button, Row, Col, Modal, ButtonToolbar } from 'reactstrap';
import Select from 'react-select';
import API from '../../../Common/api';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import uploadIcon from '../../../../images/uploadNewIcon.svg';


class HorizontalForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            employeeCode: '',
            failedModal: false,
            modalNew: false,
            fullName: '',
            email: '',
            mobile: '',
            city: '',
            role: null,
            tax_type: "",
            tax_community: "",
            inventoryOwner: null,
            dropDownData: [],
            itemCategoryList: [],
            subBrandList: [],
            warehouses: [],
            warehouses_val: [],
            availableRoles: [],
            brandList: [],
            divisionList: [],
            taxType: [],
            availableOwners: [],
            subCategoryList: [],
            taxCommunity: [],
            username_val: '',
            password: '',
            errors: {},
            isAccordionOpen: false,
            sectionStatus: {
                itemDetails: false,
                productAttributes: false,
                pricingDetails: false,
                uomDetails: false
            }
        };
    }

    Failedtoggle = () => {
        this.setState((prevState) => ({ failedModal: !prevState.failedModal }));
    }

    toggleNew = () => {
        this.setState((prevState) => ({ modalNew: !prevState.modalNew }));
    }

    toggleBack = () => {
        window.location.href = "/upload/item_master?tab=item_list";  
    }

    /*handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value, errors: { ...this.state.errors, [name]: '' } });
    };*/
    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState(
            { [name]: value, errors: { ...this.state.errors, [name]: '' } },
            () => {
                this.setState({
                    sectionStatus: {
                        itemDetails: this.isSectionComplete('itemDetails'),
                        productAttributes: this.isSectionComplete('productAttributes'),
                        pricingDetails: this.isSectionComplete('pricingDetails'),
                        uomDetails: this.isSectionComplete('uomDetails'),
                    }
                });
            }
        );
        console.log("Name",event.target.name);
        if(event.target.name == "item_category"){

            API.get('/tax/v1/item-list/product/dropdown/sub-category?category='+event.target.value)
            .then((response) => response.data)
            .then((data) => {
                /*console.log("sub_category",data.data);*/
                this.setState({
                    subCategoryList: data.data.sub_category
                })
            })
            .catch((error) => console.error(error));
            return false

        }

        if(event.target.name == "brand"){

            API.get('/tax/v1/item-list/product/dropdown/sub-brand?brand='+event.target.value)
            .then((response) => response.data)
            .then((data) => {
                console.log('sub_brand',data)
                // this.setState({
                //     subBrandList: data.data.sub_brand
                // })
            })
            .catch((error) => console.error(error));

        }
    };
    isSectionComplete = (section) => {
        switch (section) {
            case 'itemDetails':
                return (
                    this.state.item_code &&
                    this.state.item_name &&
                    this.state.item_type &&
                    this.state.item_category &&
                    this.state.sub_category &&
                    this.state.brand &&
                    /*this.state.sub_brand &&*/
                    this.state.hsn_code &&
                    this.state.hht_item_desc
                );
            case 'productAttributes':
                return (
                    this.state.ean &&
                    this.state.upc &&
                    this.state.ean_each_length &&
                    this.state.ean_each_breadth &&
                    this.state.ean_each_height &&
                    this.state.ean_cases_length &&
                    this.state.ean_cases_breadth &&
                    this.state.ean_cases_height 
                );
            case 'pricingDetails':
                return (
                    this.state.mrp &&
                    this.state.std_cost &&
                    this.state.per_qty
                );
            case 'uomDetails':
                return (
                    this.state.purchase_uom &&
                    this.state.std_purchase_price &&
                    this.state.sales_uom
                );
            default:
                return false;
        }
    };

    componentDidMount() {
        this.getDropDownData();
         const accordion = document.getElementById("create_item_accordian");
         const accordion_buttons = document.getElementsByClassName("accordion__button");
         const accordion_items = document.getElementsByClassName("accordion__item");
         const accordion__panel = document.getElementsByClassName("accordion__panel");

        if (accordion) {
            accordion.style.setProperty("width", "92%", "important");
            accordion.style.setProperty("border", "0px", "important");
        }


        if (accordion_buttons.length > 0) {  // Check if elements exist
            for (let button of accordion_buttons) {
                button.style.setProperty("background-color", "#fff", "important");
                button.style.setProperty("font-weight", "bold", "important");
            }

        }

        if (accordion_items.length > 0) {  // Check if elements exist
            for (let button of accordion_items) {
                button.style.setProperty("margin-bottom", "10px", "important");
                button.style.setProperty("border", "0px", "important");
                
            }

        }

         if (accordion__panel.length > 0) {  // Check if elements exist
            for (let button of accordion__panel) {
                button.style.setProperty("background-color", "#fff", "important");
                
                
            }

        }
    }

    handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            console.log("File selected:", file.name);
            // You can update state or handle file upload here
        }
    };

    getDropDownData = () => {
        API.get('/tax/v1/item-list/product/dropdown/')
            .then((response) => response.data)
            .then((data) => {
                console.log("dropdown",data.data.item_category);
                this.setState({
                    dropDownData: data.data,
                    itemCategoryList: data.data.item_category,
                    brandList: data.data.brand,
                    divisionList: data.data.division
                })
            })
            .catch((error) => console.error(error));
    };

    createItem = () => {
        console.log(this.state.tax_community)
        this.setState({
            loading: true
        })
        const payload = {
            item_details : {
                "sku":this.state.item_code,
                "lb_sku_product_name": this.state.item_name,
                "product_type": 0,
                "category": this.state.item_category,
                "sub_category": this.state.sub_category,
                "sub_division": this.state.division,
                "brand": this.state.brand,
                "sub_brand": this.state.sub_brand,
                "base_pack_code": this.state.item_code,
                "status": "1",
                "hsn_code": this.state.hsn_code,
                "item_description": this.state.hht_item_desc
            },
            product_attributes: {
               "ean": this.state.ean,
               "ean_each": {
                   "length": this.state.ean_each_length,
                   "breadth": this.state.ean_each_breadth,
                   "height": this.state.ean_each_height
               },
               "ean_cases": {
                   "length": this.state.ean_cases_length,
                   "breadth": this.state.ean_cases_breadth,
                   "height": this.state.ean_cases_height,
               },
               "upc": 12,
               
            },
            product_pricing: {
               "mrp": this.state.mrp,
               "std_cost": this.state.std_cost,
               "per_qty": this.state.per_qty
            },
           uom_details: {
               "purchase_uom": this.state.purchase_uom,
               "std_purchase_price": this.state.std_purchase_price,
               "sales_uom": this.state.sales_uom
           }

        };

        API.post('/tax/v1/item-list/product/', { param: payload })
            /*.then((response) => response.data)
            .then((data) => {*/
            .then((response) => {

                const { data, status } = response; // 👈 keep both data and status
            
                if(status == "201" ){
                    this.setState({
                        success_message: response.data.message,
                        modalNew: true,
                        loading: false
                    }); 
                    return false;
                }

                 if(response.data.status == "success"){
                    this.setState({
                        success_message: response.data.message,
                        modalNew: true,
                        loading: false
                    }); 
                }else{
                    
                    this.setState({
                        failed_message: response.data.message,
                        failedModal: true,
                        loading: false
                    });
                }


            })
           .catch((error) => {
               if (error.response.status == "400") {
                    const errors = error.response.data.data ? Object.entries(error.response.data.data) : [];
                    this.setState({
                        failed_message: error.response.data.message,
                        failed_errors: errors,
                        failedModal: true,
                        loading: false
                    });
                } else {
                    console.log(error);
                }
                
            });
    }
      handleAccordionToggle = (isOpen) => {
        this.setState({ isAccordionOpen: isOpen });
    };

    render() {
        const { errors, modalNew, failedModal, dropDownData } = this.state;

        return (
            <div id="createItem_container" style={{ width: '100%', margin: '1%' }}>
                
                    <Accordion 
                        id="create_item_accordian" 
                       style={{ width: '100%', maxWidth: '100vw' }} 
                        allowMultipleExpanded 
                        allowZeroExpanded
                        onChange={(expandedItems) => this.handleAccordionToggle(expandedItems.length > 0)}
                    >
                        {/* Section 1 */}
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Item Details</span>
                                    <span style={{ float: "right", color: this.state.sectionStatus.itemDetails ? "green" : "orange" }}>
                                        <i className={`fa ${this.state.sectionStatus.itemDetails ? "fa-check-circle" : "fa-exclamation-circle"}`}></i>
                                        {this.state.sectionStatus.itemDetails ? " Completed" : " Pending"}
                                    </span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">Item Code <span style={{ color: "red" }}>*</span></Label>
                                            <Input
                                                type="text"
                                                name="item_code"
                                                value={this.state.item_code}
                                                onChange={this.handleChange}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Item Name <span style={{ color: "red" }}>*</span></Label>
                                            <Input
                                                type="text"
                                                name="item_name"
                                                value={this.state.item_name}
                                                onChange={this.handleChange}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Item Type <span style={{ color: "red" }}>*</span></Label>
                                            <select
                                                name="item_type"
                                                className="form-control"
                                                value={this.state.item_type}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select Type</option>
                                                <option value={dropDownData.item_type}>{dropDownData.item_type}</option>
                                                {this.state.taxType.map((item) => (
                                                    <option key={item.value} value={item.value}>{item.label}</option>
                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>

                                </Row>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">Item Category <span style={{ color: "red" }}>*</span></Label>
                                            <select
                                                name="item_category"
                                                className="form-control"
                                                value={this.state.item_category}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select Type</option>
                                                {/*<option value={dropDownData.item_category}>{dropDownData.item_category}</option>*/}
                                                {this.state.itemCategoryList.map((item) => (
                                                  <option  value={item}>
                                                    {item}
                                                  </option>
                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Sub Category <span style={{ color: "red" }}>*</span></Label>
                                            <select
                                                name="sub_category"
                                                className="form-control"
                                                value={this.state.sub_category}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select</option>
                                               
                                                {this.state.subCategoryList.map((item) => (
                                                    <option key={item} value={item}>{item}</option>
                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Division</Label>
                                            <select
                                                name="division"
                                                className="form-control"
                                                value={this.state.division}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select</option>
                                                
                                                {this.state.divisionList.map((item) => (
                                                    <option key={item} value={item}>{item}</option>
                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>

                                </Row>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">Brand <span style={{ color: "red" }}>*</span></Label>
                                             <select
                                                name="brand"
                                                className="form-control"
                                                value={this.state.brand}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select</option>
                                                

                                                {this.state.brandList.map((item) => (
                                                    <option key={item} value={item}>{item}</option>
                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Sub Brand {/*<span style={{ color: "red" }}>*</span>*/}</Label>
                                            <select
                                                name="sub_brand"
                                                className="form-control"
                                                value={this.state.sub_brand}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select</option>
                                                

                                                { this.state.subBrandList.length > 0 &&
                                                    this.state.subBrandList.map((item) => (
                                                    <option key={item} value={item}>{item}</option>
                                                ))}
                                            </select>
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="city">Basepack</Label>
                                             <Input
                                                type="text"
                                                name="basepack"
                                                value={this.state.item_code}
                                                onChange={this.handleChange}
                                                disabled
                                                required
                                            />

                                            {/*<select
                                                name="tax_type"
                                                className="form-control"
                                                value={this.state.tax_type}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select Type</option>
                                                {this.state.taxType.map((item) => (
                                                    <option key={item.value} value={item.value}>{item.label}</option>
                                                ))}
                                            </select>*/}
                                        </FormGroup>
                                    </Col>

                                </Row>

                                 <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="username">HSN Code<span style={{ color: "red" }}>*</span></Label>
                                            <Input
                                                type="text"
                                                name="hsn_code"
                                                value={this.state.hsn_code}
                                                onChange={this.handleChange}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={8}>
                                        <FormGroup>
                                            <Label for="city">HHT Item Description<span style={{ color: "red" }}>*</span></Label>
                                             <Input
                                                type="text"
                                                name="hht_item_desc"
                                                value={this.state.hht_item_desc}
                                                onChange={this.handleChange}
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    

                                </Row>

                                <Row form>
                                    <Col md={4} style={{border: '1px solid', borderColor: '#AAAAAA33', padding: '10px'}} className="d-flex justify-content-center">
                                        <div 
                                            style={{
                                                border: "2px dashed orange",
                                                backgroundColor: "#FFF3CD",
                                                padding: "20px",
                                                textAlign: "center",
                                                width: "50%",
                                                borderRadius: "8px",
                                                cursor: "pointer"
                                            }}
                                            onClick={() => document.getElementById("fileUpload").click()}
                                        >
                                            <input
                                                type="file"
                                                id="fileUpload"
                                                style={{ display: "none" }}
                                                onChange={this.handleFileUpload}
                                                accept="image/*"
                                            />
                                             <img
                                                src={uploadIcon}
                                                alt="upload"
                                                style={{ width: '25px',  }} // Adjust size as needed
                                            />
                                            <p style={{ margin: "10px 0", color: "#000" }}>Upload Item Image</p>
                                        </div>
                                    </Col>
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>

                        {/* Section 2 */}
                        <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Product Attributes</span>
                                    <span style={{ float: "right", color: this.state.sectionStatus.productAttributes ? "green" : "orange" }}>
                                        <i className={`fa ${this.state.sectionStatus.productAttributes ? "fa-check-circle" : "fa-exclamation-circle"}`}></i>
                                        {this.state.sectionStatus.productAttributes ? " Completed" : " Pending"}
                                    </span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="email">Ean</Label>
                                            <Input
                                                type="text"
                                                name="ean"
                                                id="email"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">UPC</Label>
                                            {/* <select
                                                name="upc"
                                                className="form-control"
                                                value={this.state.upc}
                                                style={{ fontSize: 13 }}
                                                onChange={this.handleChange}
                                            >
                                                <option value="">Select Type</option>
                                                <option value={dropDownData.item_type}>{dropDownData.item_type}</option>

                                                {this.state.taxType.map((item) => (
                                                    <option key={item.value} value={item.value}>{item.label}</option>
                                                ))}
                                            </select>*/}
                                            <Input
                                                type="text"
                                                name="upc"
                                                id="upc"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row form>
                                    <span style={{fontSize: 15, fontWeight: 'bold', color: 'black', width: '100%', marginBottom: 4}}> EAN Each</span>
                                    <Col md={4}>
                                        
                                        <FormGroup>
                                            <Label for="mobile">Length</Label>
                                            <Input
                                                type="number"
                                                name="ean_each_length"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Breadth</Label>
                                            <Input
                                                type="number"
                                                name="ean_each_breadth"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                     <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Height</Label>
                                            <Input
                                                type="number"
                                                name="ean_each_height"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>

                                 <Row form>
                                    <span style={{fontSize: 15, fontWeight: 'bold', color: 'black', width: '100%', marginBottom: 4}}> EAN Cases</span>
                                    <Col md={4}>
                                        
                                        <FormGroup>
                                            <Label for="mobile">Length</Label>
                                            <Input
                                                type="text"
                                                name="ean_cases_length"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Breadth</Label>
                                            <Input
                                                type="text"
                                                name="ean_cases_breadth"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                     <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Height</Label>
                                            <Input
                                                type="text"
                                                name="ean_cases_height"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>
                         <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">Pricing Details</span>
                                    <span style={{ float: "right", color: this.state.sectionStatus.pricingDetails ? "green" : "orange" }}>
                                        <i className={`fa ${this.state.sectionStatus.pricingDetails ? "fa-check-circle" : "fa-exclamation-circle"}`}></i>
                                        {this.state.sectionStatus.pricingDetails ? " Completed" : " Pending"}
                                    </span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="email">MRP</Label>
                                            <Input
                                                type="number"
                                                name="mrp"
                                                id="email"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Std Cost</Label>
                                            <Input
                                                type="number"
                                                name="std_cost"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                
                                
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Per Qty.</Label>
                                            <Input
                                                type="number"
                                                name="per_qty"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                   
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>

                         <AccordionItem>
                            <AccordionItemHeading>
                                <AccordionItemButton id="accordion_button">
                                    <span className="accordian_title">UOM Details</span>
                                    <span style={{ float: "right", color: this.state.sectionStatus.uomDetails ? "green" : "orange" }}>
                                        <i className={`fa ${this.state.sectionStatus.uomDetails ? "fa-check-circle" : "fa-exclamation-circle"}`}></i>
                                        {this.state.sectionStatus.uomDetails ? " Completed" : " Pending"}
                                    </span>
                                </AccordionItemButton>
                            </AccordionItemHeading>
                            <AccordionItemPanel>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="email">Purchase UOM</Label>
                                            <Input
                                                type="text"
                                                name="purchase_uom"
                                                id="email"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Std Purchase Price</Label>
                                            <Input
                                                type="text"
                                                name="std_purchase_price"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row form>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Sales UOM</Label>
                                            <Input
                                                type="text"
                                                name="sales_uom"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>
                                    {/*<Col md={4}>
                                        <FormGroup>
                                            <Label for="mobile">Std Purchase Price</Label>
                                            <Input
                                                type="text"
                                                name="std_purchase_price"
                                                id="mobile"
                                                onChange={this.handleChange}
                                            />
                                        </FormGroup>
                                    </Col>*/}
                                </Row>
                            </AccordionItemPanel>
                        </AccordionItem>
                    </Accordion>

                    {this.state.isAccordionOpen && (
                    <div style={{
                       
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        backgroundColor: 'white',
                        boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.1)',
                        padding: '15px 0',
                        textAlign: 'center'
                    }}>
                        <button 
                            onClick={this.toggleBack} 
                            style={{
                                backgroundColor: 'white',
                                border: '2px solid #FBBB00',
                                color: 'black',
                                padding: '8px 22px',
                                fontSize: '16px',
                                marginRight: '10px',
                                borderRadius: '5px',
                                cursor: 'pointer'
                            }}
                        >
                            Cancel
                        </button>

                        <button 
                            onClick={this.createItem} 
                            id="createUserBtn" 
                            style={{
                                backgroundColor: '#FBBB00',
                                border: 'none',
                                color: 'black',
                                padding: '8px 22px',
                                fontSize: '16px',
                                borderRadius: '5px',
                                cursor: 'pointer'
                            }}
                        >
                            Save
                        </button>
                    </div>
                )}

                <Modal isOpen={modalNew} backdrop="static" toggle={this.toggleNew}>
                  <div className="modal__header">
                    <button
                      className="lnr lnr-cross modal__close-btn"
                      type="button"
                      style={{ right: 15 }}
                      onClick={this.toggleNew}
                    />
                  </div>
                  <div
                    className="modal__body"
                    style={{ paddingTop: 55, paddingBottom: 20 }}
                  >
                    <span
                      className="lnr lnr-thumbs-up modal__title-icon"
                      style={{ color: "#4ce1b6" }}
                    />
                    <h3>{this.state.success_message} </h3>
                    
                  </div>
                  <ButtonToolbar className="modal__footer">
                    <Button
                      style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                      className="modal_ok"
                      onClick={this.toggleBack}
                    >
                      Ok
                    </Button>
                  </ButtonToolbar>
                </Modal>

                <Modal isOpen={failedModal} backdrop="static" toggle={this.Failedtoggle}>
                    <div className="modal__header">
                      <button
                        className="lnr lnr-cross modal__close-btn"
                        type="button"
                        style={{ right: 15 }}
                        onClick={this.Failedtoggle}
                      />
                    </div>
                    <div
                      className="modal__body"
                      style={{ paddingTop: 55, paddingBottom: 20 }}
                    >
                      <span
                        className="lnr lnr-cross-circle modal__title-icon"
                        style={{ color: "red" }}
                      />
                      <h4>{this.state.failed_message} </h4>
                    </div>
                    <ButtonToolbar className="modal__footer">
                      <Button
                        style={{ backgroundColor: "#24d6a3", color: "#fff" }}
                        className="modal_ok"
                        onClick={this.Failedtoggle}
                      >
                        Ok
                      </Button>
                    </ButtonToolbar>
                </Modal>



              
            </div>
        );
    }
}

export default HorizontalForm;
